"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
/**
 * ## SelectMenu - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var SelectMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(SelectMenu, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existance
  SelectMenu.resourceType = function resourceType() {
    return 'ChoiceType_1_0_0';
  };
  function SelectMenu(props) {
    var _props$value;
    var _this;
    _this = _React$Component.call(this, props) || this;
    if (((_props$value = props.value) == null ? void 0 : _props$value.length) === 0) {
      var defaultValue = props.data.placeholderText ? '' : props.data.options[0].key;
      props.handleFieldChange(props.id, [defaultValue]);
    }
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.inputId = Math.floor(Math.random() * 999);
    return _this;
  }
  var _proto = SelectMenu.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
      value = _this$props.value,
      errorMessages = _this$props.errorMessages;
    return nextProps.value[0] !== value[0] || nextProps.errorMessages[0] !== errorMessages[0];
  };
  _proto.handleChange = function handleChange(e, fieldName) {
    var _this$props2 = this.props,
      id = _this$props2.id,
      handleFieldChange = _this$props2.handleFieldChange;
    var value = e.target.value;
    this.validate(value);
    handleFieldChange(id, [value], fieldName);
  };
  _proto.validate = function validate(value) {
    var _this$props3 = this.props,
      id = _this$props3.id,
      checkRequired = _this$props3.checkRequired,
      data = _this$props3.data,
      validateAllConstraints = _this$props3.validateAllConstraints,
      updateErrors = _this$props3.updateErrors,
      handleFieldBlur = _this$props3.handleFieldBlur;
    var errors = [];
    var required = checkRequired(value, data.isRequired);
    if (value !== '') {
      errors = validateAllConstraints(value, data.constraints);
    }
    updateErrors(id, [required].concat(errors));
    if (handleFieldBlur) {
      handleFieldBlur(value, id, [required].concat(errors));
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props4 = this.props,
      data = _this$props4.data,
      value = _this$props4.value,
      _this$props4$theme = _this$props4.theme,
      theme = _this$props4$theme === void 0 ? {} : _this$props4$theme,
      _this$props4$errorMes = _this$props4.errorMessages,
      errorMessages = _this$props4$errorMes === void 0 ? [''] : _this$props4$errorMes,
      id = _this$props4.id;
    var fieldName = data.fieldName,
      fieldLabel = data.fieldLabel,
      isRequired = data.isRequired,
      requiredMessage = data.requiredMessage,
      options = data.options,
      placeholderText = data.placeholderText;
    var selectedValue = value[0];
    var errors = errorMessages.filter(function (error) {
      return error !== '';
    });
    var idInput = fieldName + "-" + this.inputId;
    var idErrorDesc = fieldName + "-error-" + id.join('-');
    // eslint-disable-next-line

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].formField,
      key: fieldName
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: idInput,
      className: _constructedForm["default"].fieldLabel + " " + _constructedForm["default"].selectLabel + " " + theme.labelSmall
    }, fieldLabel && fieldLabel.trim(), isRequired && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].requiredNotification
    }, "*")), /*#__PURE__*/_react["default"].createElement("select", {
      name: fieldName,
      id: idInput,
      className: theme.customSelect + " " + _constructedForm["default"].selectMenu + " " + (selectedValue ? '' : _constructedForm["default"].selectMenuPlaceholder),
      onChange: function onChange(e) {
        return _this2.handleChange(e, fieldName);
      },
      value: selectedValue,
      required: isRequired,
      "aria-describedby": errors.length !== 0 && idErrorDesc
    }, placeholderText && /*#__PURE__*/_react["default"].createElement("option", {
      value: "",
      disabled: true
    }, placeholderText), options.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option.key,
        value: option.key,
        disabled: option.disabled
      }, option.label);
    })), errorMessages[0] === 'requiredMessage' ? /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: requiredMessage,
      theme: theme,
      errorLabel: idErrorDesc,
      role: "alert"
    }) : errorMessages.map(function (message, i) {
      return /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
        key: message + " + " + i,
        message: message,
        theme: theme,
        errorLabel: idErrorDesc,
        role: "alert"
      });
    }));
  };
  return SelectMenu;
}(_react["default"].Component);
exports["default"] = SelectMenu;
SelectMenu.displayName = 'SelectMenu';
SelectMenu.defaultProps = {
  data: _constructedForm2["default"].formComponents[2],
  // eslint-disable-line
  theme: {}
};